import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        marginTop: -20,
        alignSelf: 'center',
        zIndex: 1,
    },
    libelle: {
        fontSize: 12, 
        color: '#00448F', 
        fontWeight: 600,
        letterSpacing: 0.3
    }
});

export default styles